!customElements.get("op-rtrmv-product") && customElements.define("op-rtrmv-product", class extends HTMLElement {
    connectedCallback () {
        if (!window.rtrViewerMV) {
            console.error("rtrViewerMV not loaded");
            return;
        }

        this.rtrViewerMV = window.rtrViewerMV;
        this.isRtrStarted = false;
        this.isIdAvailable = false;
        this.availabilityChecked = false;

        this.locale = this.dataset.locale || window.Shopify?.locale || "en";
        this.country = this.dataset.country || window.Shopify?.country || "US";
        this.autoStart = this.dataset.autoStart === "true";

        //RTR doesn't support locale different from the locale language in country like IT or DE
        if(this.locale == 'en' && this.country != 'GB') {
            this.country = 'US';
        }

        this.initInput = {
            data: {
                id: {
                    type: "upc",
                    value: this.getAttribute("data-default-variant-barcode"),
                },
                locale: `${this.locale}-${this.country}`,
                selector: {
                    overlay: `#${this.getAttribute("data-container-id")}`
                },
                settings: {
                    buttonsVisibility: {
                        displayOverlay: "hidden"
                    },
                    overlayFullscreen: true,
                    overviewVisibility: false
                }
            },
            callbacks: {
                onClose: () => this.dialog?.close(),
            }
        }

        this.elementToDisable = this.dataset.elementToDisable ? document.querySelector(this.dataset.elementToDisable) : null;
        this.dialog = this.closest("op-dialog") || this.closest("dialog");
        
        this.mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach(({ type, attributeName, target }) => {
                if (type === "attributes" && attributeName?.includes("open") && target === this.dialog) {
                    target.open || target.dataset.open === "true" ? this.startRtr() : this.stopRtr();
                }
            });
        });

        if (this.dialog) {
            this.mutationObserver.observe(this.dialog, {
                attributes: true,
                attributeFilter: ["open", "data-open"],
            });
        } else if (this.autoStart) {
            this.startRtr();
        }

        this.rtrViewerMV.isIdAvailable(this.initInput.data.id)
            .then(result => {
                if (!result && this.elementToDisable) {
                    this.elementToDisable.disabled = true;
                }

                this.isIdAvailable = result;
                this.availabilityChecked = true;
            })
            .catch(error => {
                console.error("Error checking ID availability:", error);
            });
    }

    disconnectedCallback () {
        this.mutationObserver.disconnect();

        if (this.isRtrStarted) {
            this.stopRtr();
        }
    }

    startRtr () {
        if (!this.isIdAvailable && this.availabilityChecked) {
            console.warn("ID is not available", this.initInput.data.id.value);
            return;
        }

        if (window.rtrViewer && window.rtrViewer.isInitialized()) {
            console.warn("Disposing rtrViewer core version");
            window.rtrViewer.dispose();
        }

        this.rtrViewerMV.isInitialized()
            .then(initialized => {
                if (initialized) {
                    if (this.isRtrStarted) return;
                    this.rtrViewerMV.dispose();
                }

                this.rtrViewerMV.init(this.initInput);
                this.isRtrStarted = true;

                this.dispatchEvent(new CustomEvent("rtrmv:init", {
                    detail: {
                        lastInput: this.initInput
                    }
                }));
            })
            .catch(err => {
                console.error("Error initializing rtrViewerMV:", err);
            });
    }

    stopRtr () {
        this.rtrViewerMV.dispose();
        this.isRtrStarted = false;

        this.dispatchEvent(new CustomEvent("rtrmv:dispose", {
            detail: {
                lastInput: this.initInput
            }
        }));
    }
});